function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { isBrowser as e } from "./index.es505.js";

var a = /*#__PURE__*/_createClass(function a() {
  var _this = this,
      _localStorage$getItem;

  _classCallCheck(this, a);

  this.language = void 0;

  this.getLanguage = function () {
    return _this.language;
  };

  e() ? this.language = (_localStorage$getItem = localStorage.getItem("language")) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : "en" : this.language = "en";
});

a.instance = new a();
export { a as default };